import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { attachFingerprint$ } from '../services/helpers/fingerprint.helper';

@Injectable({
	providedIn: 'root'
})
export class FingerprintInterceptor implements HttpInterceptor {
	constructor() { }
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		const fingerprint = localStorage.getItem('fingerprint');

		const getClonedRequest = () => {
			return request.clone({
				setHeaders: {
					'X-User-Fingerprint': localStorage.getItem('fingerprint')
				}
			});
		};

		if (!fingerprint) {
			return attachFingerprint$.pipe(concatMap(() => next.handle(getClonedRequest())));
		} else {
			return next.handle(getClonedRequest());
		}
	}
}
